import { FC, useMemo } from 'react';
import { randomCongratsWord } from '@puzzlio/core';
import { cn } from './cn';
import { useBreakpoint } from './useBreakpoint';

export const SolvedTextSVG: FC<{ className?: string; text?: string }> = ({ className, text }) => {
  const displayText = useMemo(() => {
    if (text) return text;
    return randomCongratsWord();
  }, [text]);

  const isMobile = !useBreakpoint('md');
  const fontSize = isMobile ? 3.875 : 4.6;

  return (
    <svg
      viewBox="0 0 500 100"
      preserveAspectRatio="xMidYMid meet"
      overflow="visible"
      className={cn('h-full w-full', className)}
    >
      <defs>
        <filter id="sombra-dura" x="-50%" y="-50%" width="200%" height="200%">
          <feOffset dx="2" dy="2" result="offset" />
          <feFlood floodColor="black" result="color" />
          <feComposite in="color" in2="offset" operator="in" result="shadow" />
          <feMerge>
            <feMergeNode in="shadow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <text
        x="250"
        y="55"
        style={{
          fontSize: `${fontSize}rem`,
          fontFamily: '"Chinook", sans-serif',
          fontWeight: 'bold',
          dominantBaseline: 'middle',
          textAnchor: 'middle',
          fill: 'var(--black)',
          stroke: 'var(--black)',
          strokeWidth: '0.17em',
          strokeLinejoin: 'round',
          strokeLinecap: 'round',
          filter: 'url(#sombra-dura)',
        }}
      >
        {displayText}
      </text>
      <text
        x="250"
        y="55"
        style={{
          fontSize: `${fontSize}rem`,
          fontFamily: '"Chinook", sans-serif',
          fontWeight: 'bold',
          dominantBaseline: 'middle',
          textAnchor: 'middle',
          fill: 'var(--white)',
        }}
      >
        {displayText}
      </text>
    </svg>
  );
};
